export default __webpack_public_path__ + "static/media/watch.0a8cf07e.svg";